import customAxios from "./axiosConfig";

const UserInviteService = {

  // team invites

  list (params) {
    const api_url = window.Urls['userinvite-list']()
    return customAxios.get(api_url, { params: params })
  },
  invitesSent (params) {
    const api_url = window.Urls['userinvite-invites-sent']()
    return customAxios.get(api_url, { params: params })
  },
  create (data) {
    const api_url = window.Urls['userinvite-list']()
    return customAxios.post(api_url, data)
  },
  addTeamViaInvite (data) {
    const api_url = window.Urls['plan_add_team_via_invite']()
    return customAxios.post(api_url, data)
  },
  retrieve (pk, params) {
    const api_url = window.Urls['userinvite-detail'](pk)
    return customAxios.get(api_url, { params: params })
  },
  delete (pk) {
    const api_url = window.Urls['userinvite-detail'](pk)
    return customAxios.delete(api_url)
  },
  resendInvitation (token) {
    const api_url = window.Urls['userinvite_resend_invite_user'](token)
    return customAxios.get(api_url)
  },
  acceptInvitation (invite_id) {
    const api_url = window.Urls['userinvite_accept'](invite_id)
    return customAxios.post(api_url)
  },
  rejectInvitation (invite_id) {
    const api_url = window.Urls['userinvite_reject'](invite_id)
    return customAxios.delete(api_url)
  },
  listInvites () {
    const api_url = window.Urls['userinvite-list-invites']()
    return customAxios.get(api_url)
  },
  getInviteDetails (invite_code) {
    const api_url = window.Urls['userinvite_get_invite_details'](invite_code)
    return customAxios.get(api_url) 
  },

  // freelancer/accountant invites
  getFreelancerInvite (invite_id) {
    const api_url = window.Urls['freelancerinvite_detail'](invite_id)
    return customAxios.get(api_url)
  },
  rejectAccountantInvitation (invite_id) {
    const api_url = window.Urls['freelancerinvite_reject'](invite_id)
    return customAxios.delete(api_url)
  }
};

export default UserInviteService;